var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtfLRotated = function SvgAtfLRotated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 313 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 204.13V0h313v40.736H34.43V204.13H0Z",
    fill: "currentColor"
  })));
};
export { SvgAtfLRotated as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzEzIDIwNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMTU5NDhlLTA1IDIwNC4xM0wzLjA1MTc2ZS0wNSAtMS4zNjgxN2UtMDVMMzEzIDBMMzEzIDQwLjczNjVMMzQuNDMgNDAuNzM2NUwzNC40MyAyMDQuMTNMMi4xNTk0OGUtMDUgMjA0LjEzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";